import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import 'rxjs/add/operator/map';
import { CookieService } from 'ngx-cookie-service';
import { AppSettingsService } from '../appsettings/appsettings.service';
 
@Injectable()
export class AuthService 
{
	private apiUrl = environment.ProNetApiRootUrl;
	private loggedIn = new BehaviorSubject<boolean>(false);
	private userDetail:any;

	constructor(private httpClient: HttpClient, private cookies : CookieService, private router: Router, env: AppSettingsService) 
	{
		this.apiUrl = env.config.ProNetApiRootUrl;
	}
	
	authenticate(username, password) : Observable<any>{
		const headers = new HttpHeaders(
		{
			'No-Auth':'True',
			'Content-Type': 'application/json',
			'api-version': '1',
			'Access-Control-Allow-Credentials':'true'
		});

		const body= {
			username: username,
			password: password
		}

		return this.httpClient.post(`${this.apiUrl}/api/auth/login`, body, {headers:headers, withCredentials:true});
	}

	get authState(){
		return this.loggedIn.value;
	}
	
	get isLoggedIn(){
		if (!this.loggedIn.value && this.cookies.get('authToken') != "")
			this.loggedIn.next(true);

		return this.loggedIn.asObservable();
	}
	
	user(){
		if (!this.userDetail)
		{
			try 
			{
				this.userDetail = JSON.parse(localStorage.getItem('accountUser'));
			}
			catch(e){;}
		}
		return this.userDetail;
	}

	clearSession(){
		sessionStorage.clear();
		localStorage.clear();
		
		// For some reason, you have to explicitly delete the authToken and labAdmin cookies
		var authCookieDomain = window.location.hostname.split(".").splice(1).join(".");
		this.cookies.delete("authToken", "/", authCookieDomain);
		this.cookies.delete("labAdmin", "/", authCookieDomain);
		this.cookies.deleteAll();
		this.loggedIn.next(false);
	}

	logout(){
		console.log("logging out");
		this.userDetail = null;
		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json'
		});		
		const body={};
		this.httpClient.post(`${this.apiUrl}/api/auth/logout`, body, {headers:headers, withCredentials:true})
			.subscribe(
				(data:any)=>{;},
				(err:HttpErrorResponse)=>{console.log("logouterror: ", err);}
			);
		this.clearSession();
		this.router.navigate(['/login']);
	}
	
	setPassword(username, password, newPassword) : Observable<any>{
		console.log("authenticating");

		const headers = new HttpHeaders(
		{
			'No-Auth':'True',
			'Content-Type': 'application/json'
		});

		const body= {
			username: username,
			password: password,
			newPassword: newPassword
		}

		return this.httpClient.post(`${this.apiUrl}/api/auth/changepassword`, body, {headers:headers});
	}
	forgotPassword(fullname, phone, email)
	{
		const headers = new HttpHeaders(
		{
			'No-Auth':'True',
			'Content-Type': 'application/json'
		});

		const body= {
			fullName: fullname,
			phoneNumber: phone,
			emailAddress: email
		}

		return this.httpClient.post(`${this.apiUrl}/api/auth/forgotpassword`, body, {headers:headers, withCredentials:true});
	}
}